/**
 * Where the campaign is served from in production.
 *
 * Hardcoded rather than read from `window.location`. The social tags are baked
 * into a static snapshot by the prerender step, and at that moment the origin
 * is the prerender's own throwaway localhost server — a share card pointing
 * there would be dead everywhere it was posted.
 */
export const CAMPAIGN_PUBLIC_ORIGIN = "https://www.muggle-ai.com";

/** Square campaign mark, shown as the tab icon on every charity route. */
export const CAMPAIGN_ICON_PATH = "/campaign-brand/ride-to-rebuild-icon.png";

/** Share card served to social crawlers. */
export const CAMPAIGN_SOCIAL_IMAGE_PATH = "/og-charity.png";

export const CAMPAIGN_SOCIAL_IMAGE_WIDTH = "1200";

export const CAMPAIGN_SOCIAL_IMAGE_HEIGHT = "630";

export const CAMPAIGN_SOCIAL_TITLE = "Ride to Rebuild — ride a mile, donate a dollar";

/**
 * The share card's description.
 *
 * Says miles *reported*, never verified: the campaign accepts mileage on trust
 * and no public copy may claim otherwise.
 */
export const CAMPAIGN_SOCIAL_DESCRIPTION =
  "A neighbourhood ride for the families displaced by the Sea Spray Lane fire. " +
  "Bike, scooter, skateboard — anything you power yourself. Every mile reported becomes a dollar.";

export const CAMPAIGN_SOCIAL_IMAGE_ALT = "Ride to Rebuild — ride a mile, donate a dollar";
